import HttpClient from './../../services/HttpClient';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBaseNewURL, getBaseURL } from '../../services/getBaseURL';
import { getUserToken } from '../../services/utils';

const http = new HttpClient();
const baseUrlcustomize = `${getBaseURL().customize}`;
const baseUrl = `${getBaseNewURL().base}`;

const initialState = {
	isOpenSheet: false,
	transactionID: null,
	transactionData: [],
	isLoading: {
		backdrop: false,
		form: false,
		button: false,
		skeleton: false,
	},
	paymentLoading: false,
	error: '',
	customError: null,
	debts: [],
	currentDebt: {},
	errorMassege: null,
	transactionPropsData: [],
	detailInstallments: [],
	paymentURL: '',
	debtDetails: {},
	transactionItem: {},
	installmentStatusList: [],
	yearsWithInstallments: [],
	overDueDebtsDetails: null,
};

export const PostTransaction = createAsyncThunk('/transactions', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const param = {};
	const response = await http.post(`${baseUrl}/GetTransactions`, param, extraConfig).then((res) => res.data);
	return response;
});

export const getTransactionDetails = createAsyncThunk('/getTransactionDetails', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const param = {
		Id: params?.transactionId,
	};
	const response = await http
		.post(`${baseUrl}/GetTransactionDetails`, param, extraConfig)
		.then((res) => res.data);
	return response;
});

export const GetCurrentDebt = createAsyncThunk('/currentDebt', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const param = {
		'sponsorId': params?.sponsorId,
	};
	const response = await http.post(`${baseUrl}/GetCurrentDebt`, param, extraConfig).then((res) => res.data);
	return response;
});

export const GetDebtsList = createAsyncThunk('/debts', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http.post(`${baseUrl}/GetDebtsList`, params, extraConfig).then((res) => res.data);
	return response;
});

export const GetDebtsNewList = createAsyncThunk('/GetDebtsListNew', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const { isToastfy, ...rest } = params;

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http
		.post(`${baseUrl}/GetDebtsListNew`, rest, extraConfig, isToastfy)
		.then((res) => res.data);
	return response;
});

export const getDebtYears = createAsyncThunk('/GetDebtYears', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http.post(`${baseUrl}/GetDebtYears`, params, extraConfig).then((res) => res.data);
	return response;
});

export const getDebtStatusType = createAsyncThunk('/GetDebtStatusType', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http
		.post(`${baseUrl}/GetDebtStatusType`, params, extraConfig)
		.then((res) => res.data);
	return response;
});

export const GetDebtDetails = createAsyncThunk('/debtDetails', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const param = {
		'sponsorId': params?.sponosorId,
		'startDate': params?.startDate,
		'endDate': params?.endDate,
	};
	const response = await http.post(`${baseUrl}/GetDebtDetails`, param, extraConfig).then((res) => res.data);
	return response;
});

export const GetDebtDetailsNew = createAsyncThunk('/GetDebtDetailsNew', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http
		.post(`${baseUrl}/GetDebtDetailsNew`, params, extraConfig)
		.then((res) => res.data);
	return response;
});

export const GetOverDueDebtsDetails = createAsyncThunk(
	'/GetOverDueDebtsDetails',
	async (params, thunkAPI) => {
		let token = getUserToken(thunkAPI);

		const extraConfig = {
			headers: {
				'Authorization': token,
			},
		};
		const response = await http
			.post(`${baseUrl}/GetOverDueDebtsDetails`, params, extraConfig)
			.then((res) => res.data);
		return response;
	},
);

export const payOnline = createAsyncThunk('/payOnline', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);

	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const param = {
		DebtNumber: params.debtNumber,
		'ReturnURL': params.returnUrl,
	};
	const response = await http
		.post(`${baseUrlcustomize}Installments/Pay`, param, extraConfig, params?.isToastfy)
		.then((res) => {
			return res.data;
		});
	return response;
});

export const multiPayOnline = createAsyncThunk('/Installments/MultiPay', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};

	const response = await http
		.post(`${baseUrlcustomize}Installments/MultiPay`, params, extraConfig, params?.isToastfy)
		.then((res) => res.data);

	return response;
});

const transactionSlice = createSlice({
	name: 'transaction',
	initialState,
	reducers: {
		changedSheetStatus(state, action) {
			state.isOpenSheet = true;
			state.transactionID = action.payload;
		},
		setData(state, action) {
			state.transactionPropsData = action.payload;
		},
		getdetailInstallments(state, action) {
			state.detailInstallments = action.payload;
		},
		resetCustomError(state) {
			state.customError = null;
		},
	},

	extraReducers: (builder) => {
		builder
			.addCase(PostTransaction.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(PostTransaction.fulfilled, (state, action) => {
				state.isLoading.skeleton = false;
				const { Success, Content, Message } = action.payload;
				if (Success) {
					const sortedTransactions = Content.Transactions?.sort(function (a, b) {
						return new Date(b.TransactionDate) - new Date(a.TransactionDate);
					});
					state.transactionData = sortedTransactions;
				} else {
					state.errorMassege = Message;
				}
			})
			.addCase(PostTransaction.rejected, (state) => {
				state.isLoading.skeleton = false;
				state.error = 'خطا در بر قراری سرور';
			});
		builder
			.addCase(getTransactionDetails.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(getTransactionDetails.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;

				if (Success) {
					state.transactionItem = Content;
				}

				state.isLoading.skeleton = false;
			})
			.addCase(getTransactionDetails.rejected, (state) => {
				state.isLoading.skeleton = false;
				state.error = 'خطا در بر قراری سرور';
			});
		builder
			.addCase(payOnline.pending, (state) => {
				state.paymentLoading = true;
			})
			.addCase(payOnline.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;
				if (Success) {
					state.paymentURL = Content?.PaymentURL;
				}
				state.paymentLoading = false;
			})
			.addCase(payOnline.rejected, (state) => {
				state.paymentLoading = false;
				state.error = 'خطا در بر قراری سرور';
			});
		builder
			.addCase(GetCurrentDebt.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(GetCurrentDebt.fulfilled, (state, action) => {
				const { Success, Content, Status, Message } = action.payload;
				if (Success) {
					state.currentDebt = Content;
				}
				state.isLoading.skeleton = false;

				if (Status === 645 && state.customError !== null) {
					state.customError = Message;
				}
			})
			.addCase(GetCurrentDebt.rejected, (state) => {
				state.isLoading.skeleton = false;
				state.error = 'خطا در بر قراری سرور';
			});
		builder
			.addCase(GetDebtsList.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(GetDebtsList.fulfilled, (state, action) => {
				const { Success, Content, Status, Message } = action.payload;
				if (Success) {
					state.debts = Content?.Items;
				}
				state.isLoading.button = false;

				if (Status === 645) {
					state.customError = Message;
				}
			})
			.addCase(GetDebtsList.rejected, (state) => {
				state.isLoading.button = false;
				state.error = 'خطا در بر قراری سرور';
			});
		builder
			.addCase(GetDebtDetails.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(GetDebtDetails.fulfilled, (state, action) => {
				const { Success, Content, Status, Message } = action.payload;
				if (Success) {
					state.debtDetails = Content;
				}
				state.isLoading.skeleton = false;

				if (Status === 645) {
					state.customError = Message;
				}
			})
			.addCase(GetDebtDetails.rejected, (state) => {
				state.isLoading.skeleton = false;
				state.error = 'خطا در بر قراری سرور';
			});
		builder
			.addCase(getDebtYears.pending, (state) => {
				state.isLoading.form = true;
			})
			.addCase(getDebtYears.fulfilled, (state, action) => {
				const { Content } = action.payload;

				state.isLoading.form = false;

				state.yearsWithInstallments = Content?.PersianYears || [];
			})
			.addCase(getDebtYears.rejected, (state, action) => {
				state.isLoading.form = false;
				state.error = action.error.message || action.payload.Message;
			});

		builder
			.addCase(getDebtStatusType.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(getDebtStatusType.fulfilled, (state, action) => {
				const { Content } = action.payload;

				state.isLoading.button = false;
				state.installmentStatusList = Content;
			})
			.addCase(getDebtStatusType.rejected, (state, action) => {
				state.isLoading.button = false;
				state.error = action.error.message || action.payload.Message;
			});

		builder
			.addCase(GetDebtsNewList.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(GetDebtsNewList.fulfilled, (state, action) => {
				const { Content } = action.payload;

				state.debts = Content;
				state.isLoading.skeleton = false;
			})
			.addCase(GetDebtsNewList.rejected, (state, action) => {
				state.isLoading.skeleton = false;
				state.error = action.error.message || action.payload.Message;
			});

		builder
			.addCase(GetDebtDetailsNew.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(GetDebtDetailsNew.fulfilled, (state, action) => {
				const { Content } = action.payload;

				state.debtDetails = Content;
				state.isLoading.skeleton = false;
			})
			.addCase(GetDebtDetailsNew.rejected, (state, action) => {
				state.isLoading.skeleton = false;
				state.error = action.error.message || action.payload.Message;
			});
		builder
			.addCase(GetOverDueDebtsDetails.pending, (state) => {
				state.isLoading.skeleton = true;
				state.overDueDebtsDetails = null;
			})
			.addCase(GetOverDueDebtsDetails.fulfilled, (state, action) => {
				const { Content } = action.payload;

				state.overDueDebtsDetails = Content;
				state.isLoading.skeleton = false;
			})
			.addCase(GetOverDueDebtsDetails.rejected, (state, action) => {
				state.isLoading.skeleton = false;
				state.error = action.error.message || action.payload.Message;
			});
		builder
			.addCase(multiPayOnline.pending, (state) => {
				state.paymentLoading = true;
			})
			.addCase(multiPayOnline.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;
				if (Success) {
					state.paymentURL = Content?.PaymentURL;
				}
				state.paymentLoading = false;
			})
			.addCase(multiPayOnline.rejected, (state) => {
				state.paymentLoading = false;
				state.error = 'خطا در بر قراری سرور';
			});
	},
});

export const { changedSheetStatus, setData, getdetailInstallments, resetCustomError } =
	transactionSlice.actions;
export default transactionSlice.reducer;
